import { useState } from 'react';
import { Image } from 'antd';
import { useSelector } from 'react-redux';
import userAssetService from 'shared/api/user-asset.service.api';
import { getLang } from 'shared/store/selectors/lang.selector';
import { formatInitials } from 'shared/utils';
import type { User } from 'shared/types/user';
import { profilePhotoReporter } from 'src/helpers/profile-photo-reporter';
import styles from './avatar-view-overlay.module.scss';

interface AvatarViewOverlayProps {
  user: User;
}

export function AvatarViewOverlay({ user }: AvatarViewOverlayProps) {
  const lang = useSelector(getLang('PROFILE_PHOTO'));
  const [open, setOpen] = useState(false);
  const publicId = user.avatarPublicId;
  if (!publicId) return null;
  const src = userAssetService.getImageUrl(publicId);
  return (
    <>
      <button
        type="button"
        className={styles.trigger}
        onClick={() => {
          profilePhotoReporter.contactsProfilePhotoOpen(user);
          setOpen(true);
        }}
        aria-label={lang.VIEW_PHOTO_LABEL}
      />
      {/* The avatar circle is rendered by <Avatar>; this Image exists only for its
          built-in fullscreen preview, driven by the trigger above — so the inline
          thumbnail is hidden and the preview is controlled. */}
      <Image
        src={src}
        alt={formatInitials(user)}
        styles={{ root: { display: 'none' } }}
        preview={{
          open,
          src,
          onOpenChange: setOpen,
          actionsRender: () => null,
        }}
      />
    </>
  );
}
